import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { AgentNetworkUpdateDto, AgentProfileDto, AgentType } from '@workspace/data-types';
import { AuraEditWrapperComponent } from '@workspace/ng-aura';
import { AgentNetworkDisplayComponent } from '../display/agent-network-display.component';
import { AgentNetworkFormComponent } from '../form/agent-network-form.component';

@Component({
  selector: 'etxe-agent-network-edit',
  imports: [AuraEditWrapperComponent, AgentNetworkFormComponent, AgentNetworkDisplayComponent],
  templateUrl: './agent-network-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentNetworkEditComponent {
  readonly initialProfile = input<AgentProfileDto | null>(null);
  readonly initialNetwork = input<string | undefined>(undefined);
  readonly agentType = input<AgentType>('titulaire');
  readonly isEditing = model<boolean>(false);
  readonly isAllowedToEdit = input<boolean>(true);

  readonly saved = output<AgentNetworkUpdateDto>();
  readonly profileSaved = output<AgentProfileDto>();

  readonly resolvedAgentType = computed(() => {
    return this.initialProfile()?.type ?? this.agentType();
  });

  readonly currentNetwork = computed(() => {
    return this.initialNetwork() ?? this.initialProfile()?.activity?.network ?? '';
  });

  onSave(dto: AgentNetworkUpdateDto | null): void {
    if (!dto) return;
    this.saved.emit(dto);
    const profile = this.initialProfile();
    if (profile) {
      this.profileSaved.emit({
        ...profile,
        activity: {
          ...profile.activity,
          network: dto.network,
        },
      });
    }
  }
}
